<form [formGroup]="declarationFormGroup"></form>

<app-worker-declaration-list [workerId]="workerId"></app-worker-declaration-list>
